import useRootTranslation from "../../hooks/use-root-translation";
import { Button, Text } from "../common";
import {
  Body,
  Container,
  Footer,
  Header,
  TextShadow
} from "./index.styled";


const TriggeredPaywall: React.FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const { root } = useRootTranslation('private-home-page:paywall.triggered');

  return (
    <Container
      widthRem={38}
    >
        <Header
          url="https://hermes.digitalinnovation.one/assets/talent-header.png"
          minHeight="19rem"
        >
          <TextShadow
            as="p"
            fontSize={35}
            fontWeight={800}
            color={"#7F28B5"}
            maxWidth={300}
            lineHeight={40}
            margin=".5rem 1.5rem"
          >
            {root("title")}
          </TextShadow>
        </Header>
        <Body height="12rem">
          <Text
            as="p"
            fontSize={20}
            fontWeight={400}
            color={"#000"}
            margin="2rem auto"
            align="start"
          >
            {root("desc-1")}
          </Text>
          <Text
            as="p"
            fontSize={20}
            fontWeight={400}
            color={"#000"}
            margin="1.5rem auto"
            align="start"
          >
            {root("desc-2")}
          </Text>
        </Body>
        <Footer>
          <Button
            backgroundColor="#7F28B5"
            textColor="#fff"
            onClick={() => {
              handleClose();
            }}
            width="50%"
          >
            {root("continue-button")}
          </Button>
        </Footer>
      </Container>
  )
};

export default TriggeredPaywall;
